import { render, staticRenderFns } from "./unsubscriptions.vue?vue&type=template&id=f6ede258&"
import script from "./unsubscriptions.vue?vue&type=script&lang=js&"
export * from "./unsubscriptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports